export const BritishAirways = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="britishAirwaysModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/britishairway.jpg"
                    alt="British Airways print advertisement"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      British Airways Print Advertising Consumer
                    </h4>
                  </div>
                  <div className="modal-body-container">
                    <p className="helvetica-nueue">
                      <strong>OBJECTIVE</strong>
                    </p>
                    <p>
                      Remind travelers of ALL the reasons that BA is the only
                      choice for flying US to London. Use a mandatory
                      polarizing, “spokes-icon” in a full page newspaper format
                      without alienating the hip and the affluent traveler.
                    </p>
                    <p className="helvetica-nueue">
                      <strong>EXECUTION</strong>
                    </p>
                    <p>
                      Robert Morley was by this time a quite portly spokesman,
                      synonymous with BA. He tended to be seen wearing a bowler,
                      walking around London landmarks brandishing a Union Jack.
                      We were told we had to use him as the primary visual… but
                      not how. It took our client about 2 minutes to start
                      laughing and much longer to stop. We placed a specific
                      dedicated reservation number in the ad and held our
                      breath…and yes, Robert Morely as Mary Poppins did
                      significantly better than any ad to date.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
